<template>
  <aside class="adm-side">
    <div class="adm-side__brand" @click="$router.push('/dashboard')">
      <img class="adm-side__logo" :src="sliceMenu('logo.png')" alt="" />
      <span class="adm-side__name">CryptoPay</span>
    </div>

    <nav class="adm-side__nav" aria-label="管理端侧栏">
      <router-link
        v-for="item in items"
        :key="item.path"
        :to="item.path"
        class="adm-side__link"
        active-class="adm-side__link--active"
      >
        <img class="adm-side__ico" :src="iconSrc(item)" alt="" role="presentation" />
        {{ item.label }}
      </router-link>
    </nav>

    <div class="adm-side__foot">
      <button type="button" class="adm-side__logout" @click="logout">
        <img class="adm-side__logout-ico" :src="sliceMenu('login_out.png')" alt="" role="presentation" />
        退出登录
      </button>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'AdminSidebar',
  data() {
    return {
      items: [
        { path: '/dashboard', label: '账户总览', base: 'dashboard' },
        { path: '/orders', label: '订单管理', base: 'order' },
        { path: '/withdraw', label: '提现管理', base: 'withdraw' },
        { path: '/withdraw-fees', label: '提现手续费', base: 'key' },
        {
          path: '/merchants',
          label: '商家管理',
          base: 'merchant',
          icon: 'merchant.png',
          iconActive: 'merchant_choose.png'
        }
      ]
    }
  },
  methods: {
    base() {
      return process.env.BASE_URL || '/'
    },
    sliceMenu(name) {
      return this.base() + 'slices/menu/' + encodeURIComponent(name)
    },
    iconSrc(item) {
      const p = this.$route.path
      const active = p === item.path || p.startsWith(item.path + '/')
      if (item.icon && item.iconActive) {
        return this.sliceMenu(active ? item.iconActive : item.icon)
      }
      const suffix = active ? '_choose' : ''
      return this.sliceMenu(`${item.base}${suffix}.png`)
    },
    logout() {
      sessionStorage.removeItem('cryptopay_admin_token')
      sessionStorage.removeItem('admin_nickname')
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.adm-side {
  width: 232px;
  min-height: 100vh;
  flex-shrink: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.42) 0%, rgba(241, 245, 249, 0.38) 100%);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-right: 1px solid rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  padding: 20px 14px 20px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
}

.adm-side__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px 22px;
  cursor: pointer;
  user-select: none;
}

.adm-side__logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
  flex-shrink: 0;
}

.adm-side__name {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.02em;
}

.adm-side__nav {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 0;
}

.adm-side__link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  text-decoration: none;
  transition: background 0.2s, color 0.2s;

  &:hover {
    color: #2563eb;
    background: rgba(37, 99, 235, 0.06);
  }
}

.adm-side__link--active {
  color: #2563eb !important;
  background: rgba(255, 255, 255, 0.82) !important;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
}

.adm-side__ico {
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex-shrink: 0;
}

.adm-side__foot {
  padding-top: 12px;
  flex-shrink: 0;
}

.adm-side__logout {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 12px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #dc2626;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: rgba(220, 38, 38, 0.08);
  }
}

.adm-side__logout-ico {
  width: 18px;
  height: 18px;
  object-fit: contain;
}
</style>
